import { defineMessages } from 'react-intl';

/** Defined the i18n messages */
export const dataTableMessages = defineMessages({
  selectAllPageRows: {
    defaultMessage: 'Select all rows on page',
    id: 'C5C+oPfVxxD6q0MK',
    description: 'Aria-label for selecting all rows on active page.',
  },
  deselectAllPageRows: {
    defaultMessage: 'Deselect all rows on page',
    id: '5JMR3OvzJBKQ37D6',
    description: 'Aria-label for deselecting all rows on active page.',
  },
  selectRow: {
    defaultMessage: 'Select row',
    id: 'e38upyCcgHiiIfZT',
    description: 'Aria-label for selecting row.',
  },
  deselectRow: {
    defaultMessage: 'Deselect row',
    id: 'zfNvejk86vLkOzTQ',
    description: 'Aria-label for deselecting row.',
  },
  emptyColumnDefinition: {
    defaultMessage: 'Unable to render DataTable.  Check configuration.',
    id: 'R40fCJm81lYBtzm5',
    description: 'Message for empty column definition.',
  },
  actionColumnHeader: {
    defaultMessage: 'Actions',
    id: 'bB5r93sBMeEycLtd',
    description: 'Header message of action column.',
  },
  paginationControls: {
    defaultMessage: 'DataTable pagination controls',
    id: 'JgNjrcU6Pk6uVb8U',
    description: 'Aria-label for pagination controls within the DataTable.',
  },
  selectPageSize: {
    defaultMessage: 'Select page size',
    id: 'tT1Q91yIBC2+wpsM',
    description: 'Aria-label for selecting current page size.',
  },
  selectPage: {
    defaultMessage: 'Select current page',
    id: 'Psa1yEbRJtw20yK3',
    description: 'Aria-label for selecting current page index.',
  },
  ganttEmtpyState: {
    defaultMessage: 'No data has been provided',
    id: 'ER4AxWGzRNncX9C4',
    description: 'Empty state message for the gantt chart column.',
  },
  ganttErrorState: {
    defaultMessage: 'An error occurred',
    id: '3tk2SwrfLw+OooR6',
    description: 'Error state message for the gantt chart column.',
  },

  /*
   * Messages for moving columns
   */
  moveColumnLeftLabel: {
    defaultMessage: 'Move left',
    id: 'Hb5phHuz1zWpI7/Z',
    description:
      'Text in the column action item for changing the column order, moving column to the left.',
  },
  moveColumnRightLabel: {
    defaultMessage: 'Move right',
    id: 'RxaXcljpkrMAErS9',
    description:
      'Text in the column action item for changing the column order, moving column to the right.',
  },
  moveColumnUpLabel: {
    defaultMessage: 'Move up',
    id: 'ucQcLWxcEFghMJ+q',
    description:
      'Text for the arrow button that moves the column upwards and change its position in the column order within the modal.',
  },
  moveColumnDownLabel: {
    defaultMessage: 'Move down',
    id: 'uGeBsSxZGBvbrr7F',
    description:
      'Text for the arrow button that moves the column downwards and change its position in the column order within the modal.',
  },

  /* Column action messages */
  sortAscendingLabel: {
    defaultMessage: 'Sort ascending',
    id: 'oESatZ3ASn8uoein',
    description:
      'Text in the column action item for sorting the column ascendingly.',
  },
  sortDescendingLabel: {
    defaultMessage: 'Sort descending',
    id: 'jFt85Fw/eJt1wat7',
    description:
      'Text in the column action item for sorting the column descendingly.',
  },

  copyItemLabel: {
    defaultMessage: 'Copy',
    id: 'wJT2kpWSIapmn9ko',
    description:
      'Text in the cell action item for copying the content of the table cell to the clipboard.',
  },

  fontStyleCodeLabel: {
    defaultMessage: 'Change font: monospace',
    id: 'fE+5JaLlWXQ3dlNm',
    description: 'Set the font style of the column text.',
  },
  fontStyleTextLabel: {
    defaultMessage: 'Change font: default',
    id: 'Xug47ebOKpTzuLj1',
    description: 'Set the font style of the column text.',
  },

  hideColumnLabel: {
    defaultMessage: 'Hide column',
    id: 'LQ8VkjDPP6CnNrhf',
    description: 'Text in the column action item for hiding the column.',
  },

  /** toolbar labels */
  enableLineWrapLabel: {
    defaultMessage: 'Enable line wrap',
    id: 'yRTBrmuLLhgDytyG',
    description:
      'Text in the column action item for enabling line wrap for the column.',
  },
  disableLineWrapLabel: {
    defaultMessage: 'Disable line wrap',
    id: 'dxcsnLOTenNXGZkn',
    description:
      'Text in the column action item for disabling line wrap for the column.',
  },
  downloadButtonLabel: {
    defaultMessage: 'Download table data',
    description: 'Tooltip information for the download table button',
    id: '3n10F0hHNH6YVo3j',
  },
  toolbarButtonLabel: {
    defaultMessage: 'More options',
    description: 'Tooltip information for the toolbar menu button',
    id: 'wJb5aQ8q06TidoIt',
  },
  columnSettingsLabel: {
    defaultMessage: 'Column settings',
    description: 'Tooltip information for the column settings button',
    id: 'DoSCFZmkm4Wgk+9J',
  },

  /** column visibility */
  columnSettingsModalTitle: {
    defaultMessage: 'Columns',
    id: 'tznlZbNaiUJ1dPqb',
    description: 'Column settings modal title',
  },
  showHideAll: {
    defaultMessage: 'Show/hide all',
    id: 'xYagPfCP0AY72G3+',
    description: 'Show or hide all checkbox label',
  },
  searchBarPlaceholder: {
    defaultMessage: 'Search',
    id: 'TIVnKWerQ6BuCdAB',
    description: 'Search placeholder',
  },
  cancelButtonText: {
    defaultMessage: 'Cancel',
    id: 'euRey+Fz9NxskAuO',
    description: 'Cancel button text',
  },
  applyButtonText: {
    defaultMessage: 'Apply',
    id: 'oVgkJujKiRvYqIFQ',
    description: 'Apply button text',
  },
  noItemsFound: {
    defaultMessage: 'No items found.',
    id: 'IOULVwhMHJJA+fW7',
    description: 'Message for when search filter does not match any items.',
  },
  resetColumnSettingsButtonText: {
    defaultMessage: 'Reset to default',
    id: 'A1+FGKx7bONltqJV',
    description: 'Resets column settings to default',
  },
  ariaLabelDragAndDrop: {
    defaultMessage: 'Drag to reorder "{column}" column',
    description: 'Aria label for DataTable draggable header',
    id: 'RicigT+v0BvVWaSt',
  },
  ariaLabelSorting: {
    defaultMessage:
      'Change sorting for "{column}" column to {direction, select, asc {ascending} desc {descending} other {unset}}',
    description: 'Aria label for DataTable header actions trigger',
    id: '3mLewkoS0YrrKazC',
  },
  ariaLabelSortingDragAndDrop: {
    defaultMessage:
      'Change sorting for "{column}" column to {direction, select, asc {ascending} desc {descending} other {unset}} or drag to reorder "{column}" column.',
    description: 'Aria label for DataTable header actions trigger',
    id: 'tHZFxUeAnUZlB1UH',
  },
  ariaLabelUserActions: {
    defaultMessage: 'Trigger actions for "{column}" column',
    description: 'Aria label for DataTable header actions trigger',
    id: 'rgFCDIrM4Icoiw7+',
  },
  ariaLabelUserActionsDragAndDrop: {
    defaultMessage:
      'Trigger actions for "{column}" column or drag to reorder "{column}" column.',
    description: 'Aria label for DataTable header actions trigger',
    id: '5pedJkZuALCOJA/w',
  },
});
